var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _c("span", { staticClass: "visually-hidden" }, [
        _vm._v(_vm._s(_vm.offerNameAccessibility)),
      ]),
      _vm._v(" "),
      _c("ob1-boutons", {
        class: _vm.additionalClasses,
        attrs: {
          "data-bs-toggle": "modal",
          "data-bs-target": "#" + _vm.popinId,
          "is-primary": _vm.isPrimary,
          "is-secondary": !_vm.isPrimary,
          "is-inverse": _vm.isInverse,
          "is-wide": _vm.isWide,
          "is-button": !_vm.isLink,
          label: _vm.label,
          "aria-hidden": "true",
          "data-oevent-category": _vm.trackingCategory,
          "data-oevent-action": _vm.getLabelToTmsFormat(_vm.label),
          "data-oevent-label": _vm.trackingLabel,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.fromCds
            ? _c("with-device-popin-cds", {
                attrs: {
                  id: _vm.popinId,
                  "with-device-section": _vm.popinCtasDto.withDeviceSection,
                  "without-device-section":
                    _vm.popinCtasDto.withoutDeviceSection,
                  title: _vm.popinCtasDto.title,
                  description: _vm.popinCtasDto.description,
                  visual: _vm.popinCtasDto.visual,
                  "is-sub": _vm.isSub,
                },
              })
            : _c("with-device-popin", {
                attrs: {
                  id: _vm.popinId,
                  "with-device-section": _vm.popinCtasDto.withDeviceSection,
                  "without-device-section":
                    _vm.popinCtasDto.withoutDeviceSection,
                  title: _vm.popinCtasDto.title,
                  description: _vm.popinCtasDto.description,
                  visual: _vm.popinCtasDto.visual,
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }